import React, { useState } from "react";
import { Lock, User, LogIn } from "lucide-react";
import { adminApi, setToken } from "./adminApi";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await adminApi.login(username, password);
      setToken(res.data.token);
      onLogin(res.data.username);
    } catch (err) {
      setError("Credenziali non valide. Riprova.");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-white border border-[#e0d6c2] rounded-[2px] pl-11 pr-4 py-3 text-[#23201C] outline-none focus:border-[#C9A24B] focus:ring-2 focus:ring-[#C9A24B]/20 transition";

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1C1815] px-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <p className="font-display text-3xl text-white">L'angolo <span className="italic text-[#C9A24B]">del Gusto</span></p>
          <p className="text-xs tracking-[0.35em] uppercase text-white/40 mt-2">Pannello di gestione</p>
        </div>
        <form onSubmit={submit} className="bg-[#FBF7F0] rounded-[2px] p-8 shadow-2xl">
          <h1 className="font-display text-2xl text-[#23201C] mb-6">Accedi</h1>
          {error && <div className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-[2px] px-4 py-2.5">{error}</div>}
          <div className="space-y-4">
            <div className="relative">
              <User size={17} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#C9A24B]" />
              <input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Username" className={inputCls} />
            </div>
            <div className="relative">
              <Lock size={17} className="absolute left-4 top-1/2 -translate-y-1/2 text-[#C9A24B]" />
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className={inputCls} />
            </div>
          </div>
          <button type="submit" disabled={loading}
            className="mt-6 w-full flex items-center justify-center gap-2 bg-[#1C1815] hover:bg-[#2a241f] text-[#C9A24B] px-6 py-3.5 rounded-full font-medium tracking-wide transition-all duration-300 disabled:opacity-60">
            {loading ? "Accesso..." : "Entra"} <LogIn size={16} />
          </button>
        </form>
        <p className="text-center text-white/30 text-xs mt-6">Torna al <a href="/" className="text-[#C9A24B] hover:underline">sito</a></p>
      </div>
    </div>
  );
}